import { render } from "./GeneralTestingTestPage.vue?vue&type=template&id=747c1dda&scoped=true"
import script from "./GeneralTestingTestPage.vue?vue&type=script&lang=js"
export * from "./GeneralTestingTestPage.vue?vue&type=script&lang=js"

import "./GeneralTestingTestPage.vue?vue&type=style&index=0&id=747c1dda&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747c1dda"]])

export default __exports__